import React from 'react'
import { connect } from 'react-redux'
import OrderStatistics from '../components/OrderStatistics'

const Statistics = ({orders,clients,products}) =>
  <React.Fragment>
    <div className="row">
      <div className="col-sm-12">
        <div className="page-title-box">
          <h4 className="page-title">Statistik</h4>
          <div className="clearfix"/>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-12">
        { orders && orders.length>0 && <OrderStatistics orders={orders}/>}
      </div>
    </div>
  </React.Fragment>


export default connect(
  state => ({
    orders: state.orders.items,
    products: state.products.items,
    clients: state.clients
  }),
  dispatch => ({
  })
)(Statistics)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/Statistics.js